const config = {
  baseURL: 'https://centralize.undefined.co.th:4441',
  // baseURL: 'http://localhost:3001',
  // baseURLV2: 'https://spare-nodejs-api.undefined.co.th:4439'
  baseURLV2: 'http://localhost:6100'
  // baseURLV2: 'https://marim-api-santithum.undefined.co.th:4439'
}

export default config



// WEBPACK FOOTER //
// ./src/services/config.js